let language: 'en' | 'zh' | '_ch' = window.myAppStrapi && window.myAppStrapi.currentLang ? window.myAppStrapi.currentLang : 'en';

if (language === '_ch') {
  language = 'zh';
}

export default language;